import type { NavLink, GalleryCategory } from "@/types";

// Site configuration
export const SITE_CONFIG = {
  name: "Alex Chen Photography",
  tagline: "Capturing moments, creating memories",
  description:
    "Professional photographer specializing in portraits, landscapes, and editorial work. Based in Los Angeles, available worldwide.",
  author: "Alex Chen",
  location: "Los Angeles, CA",
  timezone: "PST (UTC-8)",
  email: "hello@alexchen.photo",
  phone: "+1 (555) 123-4567",
} as const;

// Navigation links
export const NAV_LINKS: NavLink[] = [
  { name: "Home", href: "/" },
  { name: "Gallery", href: "/gallery" },
  { name: "About", href: "/about" },
  { name: "Contact", href: "/contact" },
] as const;

// Gallery categories
export const GALLERY_CATEGORIES: GalleryCategory[] = [
  "All",
  "Portraits",
  "Street",
  "Landscape",
  "Editorial",
  "Events",
  "Architecture",
] as const;

// Social media links
export const SOCIAL_LINKS = [
  {
    name: "Instagram",
    icon: "ri-instagram-line",
    href: "https://instagram.com/alexchen_photo",
  },
  {
    name: "Behance",
    icon: "ri-behance-line",
    href: "https://behance.net/alexchen",
  },
  {
    name: "LinkedIn",
    icon: "ri-linkedin-line",
    href: "https://linkedin.com/in/alexchen-photo",
  },
] as const;

// Contact form project types
export const PROJECT_TYPES = [
  { value: "", label: "Select project type" },
  { value: "portrait", label: "Portrait Session" },
  { value: "wedding", label: "Wedding Photography" },
  { value: "event", label: "Event Coverage" },
  { value: "commercial", label: "Commercial Work" },
  { value: "editorial", label: "Editorial Assignment" },
  { value: "other", label: "Other" },
] as const;

// Form validation
export const FORM_VALIDATION = {
  messageMaxLength: 500,
  responseTimeHours: 24,
} as const;

// Responsive breakpoints (in pixels)
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const;

// Animation durations (in milliseconds)
export const ANIMATION = {
  fast: 150,
  normal: 300,
  slow: 500,
} as const;
